import { EventApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY, PARTNER_KEY } from './keys';

function useUpdatePartners() {
  const queryClient = useQueryClient();

  return useAuthMutation(EventApi.putPartners, {
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: getQueryKeys([KEY]).detail(String(variables.id || '')),
      });
      queryClient.invalidateQueries({
        queryKey: getQueryKeys(PARTNER_KEY).detail(String(variables.id || '')),
      });
    },
  });
}

export default useUpdatePartners;
